import { useEffect, useState } from 'react'

const useSticky = (elementRef) => {
    const [isSticky, setIsSticky] = useState(false)

    useEffect(() => {
        const handleScroll = () => {
            const { y } = elementRef.current.getBoundingClientRect()
            setIsSticky(y <= 0)
        }

        // Attach the scroll event listener
        window.addEventListener('scroll', handleScroll)

        // Cleanup the event listener on unmount
        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])

    return isSticky
}

export default useSticky
